import values from 'mout/object/values'
import getSubtest from "./getSubtest"
import sortByPropText from "../content/manageSets/sortByPropText";
import totalArray from '../totalArray';

export default function getPacingRating(userAssessment) {

  const ratingThresholds = {
    'English': [
      {percent: 15, rating: 5},
      {percent: 25, rating: 4},
      {percent: 35, rating: 3},
      {percent: 45, rating: 2},
      {percent: 55, rating: 1},
    ],
    'Math': [
      {percent: 20, rating: 5},
      {percent: 30, rating: 4},
      {percent: 40, rating: 3},
      {percent: 50, rating: 2},
      {percent: 60, rating: 1},
    ],
    'Reading': [
      {percent: 15, rating: 5},
      {percent: 25, rating: 4},
      {percent: 35, rating: 3},
      {percent: 45, rating: 2},
      {percent: 55, rating: 1},
    ],
    'Science': [
      {percent: 20, rating: 5},
      {percent: 30, rating: 4},
      {percent: 40, rating: 3},
      {percent: 50, rating: 2},
      {percent: 60, rating: 1},
    ]
  }
  
  function getItemsFrontOrBackER(userAssessment, subject, frontOrBack) {
    const subtest = getSubtest(subject, userAssessment)
    const subtestId = subtest.setId
    const byItem = userAssessment.scoring.byItem[subtestId]
    const items = sortByPropText(values(byItem), 'index')
    const passageBreak = {
      'English': 3,
      'Reading': 2,
    }
    const bkpt = passageBreak[subject]
    if (bkpt === undefined) {
      return []
    }
    if (!subtest.sectionBreaks) return []
    const breakpoint = subtest.sectionBreaks[bkpt] - 1
    if (frontOrBack === 'front') {
      return items.slice(0, breakpoint)
    } else if (frontOrBack === 'back') {
      return items.slice(breakpoint)
    } else {
      return []
    }
  }

  function calculatePercentage(items) {
    let totalRaw = 0, totalPossible = 0
    items.forEach(function addToTotals(item) {
      totalRaw += parseInt(item.raw, 10)
      totalPossible += parseInt(item.possible, 10)
    })
    return totalRaw / totalPossible
  }

  function checkRating(ratingThresholds, subject, score, ratingTest) {
    const ratings = ratingThresholds[subject]
    let rating = 1, ratingFound = false
    ratings.forEach(function seeIfRatingApplies(r) {
      if (!ratingFound && ratingTest(r, score)) {
        ratingFound = true
        rating = r.rating
      }
    })
    return rating
  }

  function calculateSubjectRatingER(subject, userAssessment, ratingThresholds) {
    const front = calculatePercentage(getItemsFrontOrBackER(userAssessment, subject, 'front'))
    const back = calculatePercentage(getItemsFrontOrBackER(userAssessment, subject, 'back'))
    let score
    if (back !== 0) {
      score = Math.round((front / back - 1) * 100)
    } else {
      score = 100
    }
    function ratingTest (r, score) {
      return score < r.percent
    }
    return checkRating(ratingThresholds, subject, score, ratingTest)
  }

  function findMathBreaks(scale) {
    if (scale > 30) {
      return {front: 50, back: 55}
    } else if (scale > 25) {
      return {front: 45, back: 50}
    } else if (scale > 20) {
      return {front: 40, back: 45}
    } else if (scale > 16) {
      return {front: 35, back: 40}
    } else {
      return {front: 30, back: 35}
    }
  }

  function getItemsFrontOrBackMath(userAssessment, frontOrBack) {
    const subtest = getSubtest('Math', userAssessment)
    const subtestId = subtest.setId
    const byItem = userAssessment.scoring.byItem[subtestId]
    const items = sortByPropText(values(byItem), 'index')
    const scale = userAssessment.scoring.bySubtest[subtestId] ? Number(userAssessment.scoring.bySubtest[subtestId].scale) : 0
    const breaks = findMathBreaks(scale)
    if (frontOrBack === 'front') {
      return items.slice(breaks.front, breaks.front + 5)
    } else if (frontOrBack === 'back') {
      return items.slice(breaks.back, breaks.back + 5)
    } else {
      return null
    }
  }

  function calculateSubjectRatingMathScience(userAssessment, ratingThresholds, subject) {
    let frontItems, backItems
    if (subject === 'Math') {
      frontItems = getItemsFrontOrBackMath(userAssessment, 'front')
      backItems = getItemsFrontOrBackMath(userAssessment, 'back')
    } else if (subject === 'Science') {
      frontItems = getItemsFrontOrBackScience(userAssessment, 'front')
      backItems = getItemsFrontOrBackScience(userAssessment, 'back')
    }
    const front = calculatePercentage(frontItems)
    const back = calculatePercentage(backItems)
    let score
    if (back !== 0) {
      score = Math.round((front / back - 1) * 100)
    } else {
      score = 100
    }
    function ratingTest (r, score) {
      return score < r.percent
    }
    return checkRating(ratingThresholds, subject, score, ratingTest)
  }

  function getItemsFrontOrBackScience(userAssessment, frontOrBack) {
    const subtest = getSubtest('Science', userAssessment)
    const subtestId = subtest.setId
    const byItem = userAssessment.scoring.byItem[subtestId]
    const items = sortByPropText(values(byItem), 'index')
    const scale = userAssessment.scoring.bySubtest[subtestId]
      ? Number(userAssessment.scoring.bySubtest[subtestId].scale)
      : 0
    let start, end
    if (!subtest.sectionBreaks) {
      start = 0
      end = 0 
    } else if (scale > 27 && frontOrBack === 'front') {
      start = 0
      end = subtest.sectionBreaks[4] - 1
    } else if (scale > 27 && frontOrBack === 'back') {
      start = subtest.sectionBreaks[4] - 1
      end = 39
    } else if (scale > 18 && frontOrBack === 'front') {
      start = 0
      end = subtest.sectionBreaks[3] - 1
    } else if (scale > 18 && frontOrBack === 'back') {
      start = subtest.sectionBreaks[3] - 1
      end = subtest.sectionBreaks[5] - 1
    } else if (frontOrBack === 'front') {
      start = 0
      end = subtest.sectionBreaks[2] - 1
    } else if (frontOrBack === 'back') {
      start = subtest.sectionBreaks[2] - 1
      end = subtest.sectionBreaks[4] - 1
    }
    return items.slice(start, end)
  }

  function computePacing(userAssessment, ratingThresholds) {
    let pacing = {
      'English': calculateSubjectRatingER('English', userAssessment, ratingThresholds),
      'Math': calculateSubjectRatingMathScience(userAssessment, ratingThresholds, 'Math'),
      'Reading': calculateSubjectRatingER('Reading', userAssessment, ratingThresholds),
      'Science': calculateSubjectRatingMathScience(userAssessment, ratingThresholds, 'Science'),
    }
    pacing.stars = Math.round(totalArray(values(pacing)) / 4)
    return pacing
  }

  return computePacing(userAssessment, ratingThresholds)
}


// WEBPACK FOOTER //
// ./src/helpers/assessment/getPacingRating.js